import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Onesevenbusonrentinpune() {



  const cardData = {
"keyword": "17 Seater Bus on Rent in Pune",

"headingDescription":
  "Aaradhya Travels provides comfortable and affordable 17 Seater Bus on Rent in Pune for family tours, weddings, corporate travel, airport transfers, school trips, pilgrimage journeys, and outstation group travel. Our well-maintained AC buses with spacious seating and experienced drivers ensure safe and smooth journeys across Pune and nearby destinations.",

"topPlaces": [
 
  {
    "title": "Panchgani",
    "description":
      "Panchgani attracts visitors with Table Land, fresh air, mountain scenery, strawberry farms, and peaceful nature surroundings. Group travelers commonly choose bus rentals for hill station travel."
  },
   {
    "title": "Khandala",
    "description":
      "Khandala is famous for misty valleys, mountain landscapes, waterfalls, and peaceful surroundings. Group travelers prefer comfortable bus journeys from Pune for relaxing vacations and nature tours."
  },
  {
    "title": "Shirdi",
    "description":
      "Shirdi is a major pilgrimage destination visited by Sai Baba devotees from across India. Families and religious groups often hire 17 seater buses for comfortable temple darshan tours."
  },
  {
    "title": "Nashik",
    "description":
      "Nashik is famous for Trimbakeshwar Temple, vineyards, wine tourism, river ghats, and spiritual tourism. Group bus travel from Pune is popular for pilgrimage and sightseeing tours."
  },
  {
    "title": "Mumbai",
    "description":
      "Mumbai is known for Marine Drive, Gateway of India, Juhu Beach, shopping streets, Bollywood attractions, nightlife, and business hubs. Corporate groups and families frequently travel by rental buses from Pune."
  },
   {
    "title": "Lonavala",
    "description":
      "Lonavala is a popular hill station near Pune known for waterfalls, green valleys, Tiger Point, Bhushi Dam, caves, scenic mountain roads, and monsoon beauty. Families and tourist groups frequently hire 17 seater buses for weekend trips and sightseeing tours."
  },
 
  {
    "title": "Mahabaleshwar",
    "description":
      "Mahabaleshwar is one of Maharashtra’s most famous hill stations known for strawberry farms, Venna Lake, scenic viewpoints, waterfalls, and cool weather. 17 seater bus rentals are ideal for family vacations and group sightseeing."
  },
  {
    "title": "Goa",
    "description":
      "Goa is one of the top tourist destinations known for beaches, nightlife, churches, seafood, water sports, and beach resorts. Friends groups and holiday travelers often hire buses for Goa road trips."
  },
  {
    "title": "Lavasa",
    "description":
      "Lavasa is a planned hill city near Pune famous for lakeside views, colorful architecture, cafes, and adventure activities. Bus rentals are commonly used for corporate outings and family trips."
  },
  {
    "title": "Sinhagad Fort",
    "description":
      "Sinhagad Fort is a historic fort near Pune known for trekking, mountain views, monsoon tourism, and Maratha history. Tourist groups often travel by rental buses for day tours."
  },
  
],



services: [
  {
    name: "17 Seater Bus on Rent Pune",
    description: "17 seater bus on rent Pune service provides spacious and comfortable transportation for family tours, corporate outings, airport transfers, wedding travel, picnic trips, and outstation journeys. Well-maintained buses ensure smooth highway travel suitable for medium-sized group transportation requirements. Professional chauffeurs ensure safe driving and punctual pickup services throughout the journey. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune. Flexible booking options allow convenient 17 seater bus reservations."
  },
  {
    name: "17 Seater Bus on Rent in Pune Price",
    description: "17 seater bus on rent in Pune price service offers affordable and transparent transportation solutions for local travel, tourist tours, educational trips, and family vacations. Spacious seating and comfortable interiors ensure smooth journeys suitable for group travel requirements. Professional drivers ensure safe driving and reliable transportation services throughout the route. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune. Flexible booking options allow convenient 17 seater bus rental reservations."
  },
  {
    name: "17 Seater Bus Rate Per KM in Pune",
    description: "17 seater bus rate per km in Pune service provides economical and dependable transportation for airport transfers, outstation travel, corporate trips, and sightseeing tours. Comfortable buses ensure smooth highway journeys suitable for long-distance and local travel requirements. Professional chauffeurs ensure safe driving and punctual pickup services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune. Flexible booking options allow convenient per km bus reservations."
  },
  {
    name: "17 Seater Bus on Rent in Pune",
    description: "17 seater bus on rent in Pune service offers reliable transportation for school trips, wedding functions, business meetings, family tours, and group travel requirements. Spacious seating and luggage space ensure comfortable travel experiences suitable for all passenger groups. Professional drivers ensure safe driving and dependable transportation services throughout the journey. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune. Flexible booking options allow convenient 17 seater bus bookings."
  },
  {
    name: "17 Seater AC Tempo Traveller On Rent in Pune",
    description: "17 seater AC Tempo Traveller on rent in Pune service provides premium air-conditioned transportation for family vacations, corporate travel, sightseeing tours, and outstation journeys. Comfortable pushback seating and cooling systems ensure pleasant travel experiences during all seasons. Professional chauffeurs ensure safe driving and punctual pickup services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune. Flexible booking options allow convenient AC traveller reservations."
  },
  {
    name: "17 Seater Non AC Tempo Traveller on Rent in Pune",
    description: "17 seater non AC Tempo Traveller on rent in Pune service offers economical transportation for educational tours, local travel, family outings, and short-distance group journeys. Spacious interiors and comfortable seating ensure smooth travel experiences suitable for budget-friendly group transportation. Professional chauffeurs ensure safe driving and dependable transportation services throughout the trip. Pickup services are available from homes, offices, schools, hotels, railway stations, and airports across Pune. Flexible booking options allow convenient non AC traveller reservations."
  },
  {
    name: "17 Seater Tempo Traveller for Mahabaleshwar from Pune",
    description: "17 seater Tempo Traveller for Mahabaleshwar from Pune service provides comfortable hill station transportation for family vacations, sightseeing tours, weekend trips, and corporate outings. Spacious seating and smooth suspension ensure pleasant ghat road journeys suitable for all passenger groups. Professional drivers ensure safe driving and reliable transportation services throughout the Mahabaleshwar route. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient Mahabaleshwar traveller reservations."
  },
  {
    name: "17 Seater Tempo Traveller for Pune to Goa",
    description: "17 seater Tempo Traveller for Pune to Goa service offers premium transportation for beach vacations, tourist travel, family holidays, bachelor trips, and corporate outings from Pune. Spacious vehicles ensure comfortable overnight and long-distance journeys with ample luggage capacity for passengers. Professional chauffeurs ensure safe highway driving and dependable transportation services throughout the Goa route. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune. Flexible booking options allow convenient Goa traveller reservations."
  },
  {
    name: "17 Seater Tempo Traveller Pune to Nashik",
    description: "17 seater Tempo Traveller Pune to Nashik service provides dependable transportation for pilgrimage tours, wine tourism, family vacations, and sightseeing trips from Pune. Comfortable seating and spacious interiors ensure smooth highway journeys suitable for tourists and group passengers. Professional drivers ensure safe driving and punctual pickup services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient Nashik traveller reservations."
  },
  {
    name: "17 Seater Tempo Traveller Pune to Mumbai Rent",
    description: "17 seater Tempo Traveller Pune to Mumbai rent service offers reliable transportation for corporate travel, airport transfers, wedding events, family tours, and business trips between Pune and Mumbai. Spacious seating and luggage capacity ensure smooth expressway journeys suitable for group transportation requirements. Professional chauffeurs ensure safe driving and dependable transportation services throughout the route. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune. Flexible booking options allow convenient Mumbai traveller reservations."
  },
  {
    name: "17 Seater Tempo Traveller on Rent in Hadapsar",
    description: "17 seater Tempo Traveller on rent in Hadapsar service provides comfortable transportation for local sightseeing, airport transfers, family outings, and outstation group travel from Hadapsar Pune. Spacious vehicles ensure smooth journeys suitable for tourists, office teams, and family passengers. Professional drivers ensure safe transportation and punctual pickup services throughout the route. Pickup services are available from residential societies, offices, hotels, and commercial locations across Hadapsar Pune. Flexible booking options allow convenient traveller reservations."
  },
  {
    name: "17 Seater Tempo Traveller on Rent in Pimpri Chinchwad",
    description: "17 seater Tempo Traveller on rent in Pimpri Chinchwad service offers dependable transportation for corporate travel, educational tours, airport transfers, and family vacations from Pimpri Chinchwad Pune. Comfortable seating and spacious interiors ensure pleasant travel experiences suitable for all passenger groups. Professional chauffeurs ensure safe driving and reliable transportation services throughout the route. Pickup services are available from homes, offices, hotels, and commercial locations across Pimpri Chinchwad. Flexible booking options allow convenient traveller reservations."
  },
  {
    name: "17 Seater Tempo Traveller Hire in Viman Nagar",
    description: "17 seater Tempo Traveller hire in Viman Nagar service provides premium transportation for airport transfers, corporate travel, business meetings, and tourist journeys from Viman Nagar Pune. Spacious seating and luggage capacity ensure smooth travel experiences suitable for long-distance and local group travel. Professional drivers ensure safe driving and punctual pickup services throughout the route. Pickup services are available from homes, hotels, offices, Pune Airport, and commercial locations across Viman Nagar. Flexible booking options allow convenient traveller reservations."
  },
  {
    name: "Pune to Shirdi 17 Seater Bus Booking",
    description: "Pune to Shirdi 17 seater bus booking service provides reliable transportation for Sai Baba darshan tours, pilgrimage travel, family trips, and spiritual journeys from Pune. Comfortable buses ensure smooth highway travel suitable for devotees, families, and senior citizens. Professional chauffeurs ensure safe driving and dependable transportation services throughout the Shirdi route. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune. Flexible booking options allow convenient Shirdi bus reservations."
  },
  {
    name: "17 Seater Bus",
    description: "17 seater bus service provides spacious and dependable transportation for family functions, educational tours, airport transfers, sightseeing trips, corporate outings, and outstation journeys. Comfortable interiors and smooth highway performance ensure pleasant travel experiences suitable for group passengers. Professional chauffeurs ensure safe driving and punctual pickup services throughout the route. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune. Flexible booking options allow convenient 17 seater bus reservations."
  }
],

tableData: [
  ["17 Seater Bus on Rent Pune", "17 Seater Bus on Rent in Pune Price"],
  ["17 Seater Bus Rate Per KM in Pune", "17 Seater Bus on Rent in Pune"],
  ["17 Seater AC Tempo Traveller On Rent in Pune", "17 Seater Non AC Tempo Traveller on Rent in Pune"],
  ["17 Seater Tempo Traveller for Mahabaleshwar from Pune", "17 Seater Tempo Traveller for Pune to Goa"],
  ["17 Seater Tempo Traveller Pune to Nashik", "17 Seater Tempo Traveller Pune to Mumbai Rent"],
  ["17 Seater Tempo Traveller on Rent in Hadapsar", "17 Seater Tempo Traveller on Rent in Pimpri Chinchwad"],
  ["17 Seater Tempo Traveller Hire in Viman Nagar", "Pune to Shirdi 17 Seater Bus Booking"],
  ["17 Seater Bus", "17 Seater Bus on Rent Pune"]
],


 whychoose: [
      {
        WhyChooseheading: "Reliable 17 Seater Bus on Rent in Pune",
        WhyChoosedescription: "Aaradhya Travels provides reliable 17 seater bus rental service in Pune with comfortable vehicles, professional drivers, and smooth travel arrangements for family trips, corporate tours, and group travel."
      },
      {
        WhyChooseheading: "Affordable 17 Seater Bus Rental Packages",
        WhyChoosedescription: "Aaradhya Travels offers affordable 17 seater bus on rent in Pune with transparent pricing, flexible booking options, and complete travel support without hidden charges."
      },
      {
        WhyChooseheading: "24/7 Bus Booking Service in Pune",
        WhyChoosedescription: "Our 17 seater bus rental service in Pune operates 24 hours for airport transfers, weddings, corporate travel, school trips, outstation tours, and pilgrimage journeys."
      },
      {
        WhyChooseheading: "Comfortable & Fully AC 17 Seater Buses",
        WhyChoosedescription: "All 17 seater buses provided by Aaradhya Travels are spacious, air-conditioned, clean, and regularly maintained to provide safe and comfortable travel experiences."
      },
      {
        WhyChooseheading: "One Day & Multi-Day Group Tours",
        WhyChoosedescription: "Aaradhya Travels offers flexible travel plans including one-day tours, weekend trips, multi-day outstation journeys, and customized travel packages according to customer requirements."
      },
      {
        WhyChooseheading: "Perfect for Family & Corporate Group Travel",
        WhyChoosedescription: "The 17 seater bus is ideal for family vacations, corporate outings, wedding transportation, tourist groups, educational tours, and group sightseeing travel from Pune."
      },
      {
        WhyChooseheading: "Pickup Available Across Pune City",
        WhyChoosedescription: "Aaradhya Travels provides doorstep pickup from Pune Airport, railway stations, hotels, homes, and major Pune areas including Baner, Wakad, Hinjewadi, Kharadi, and Hadapsar."
      },
      {
        WhyChooseheading: "Experienced Drivers for Safe Highway Travel",
        WhyChoosedescription: "Our experienced drivers ensure safe driving, smooth highway journeys, and timely travel for local and outstation group transportation requirements."
      }
    ]
  };

  const faqData = [
    { question: "What is 17 seater bus on rent in Pune?", answer: "17 seater bus rental service in Pune provides comfortable group transportation for family trips, corporate travel, weddings, and outstation tours." },
    { question: "Is 17 seater bus booking available 24 hours?", answer: "Yes, Aaradhya Travels provides 24/7 17 seater bus rental service in Pune." },
    { question: "Can I book 17 seater bus for outstation travel?", answer: "Yes, customers can book 17 seater buses for outstation tours, hill station trips, pilgrimage journeys, and holiday travel." },
    { question: "Do you provide 17 seater buses for corporate events?", answer: "Yes, Aaradhya Travels provides 17 seater bus rental service for corporate meetings, office outings, conferences, and employee transportation." },
    { question: "Are all 17 seater buses air-conditioned?", answer: "Yes, all 17 seater buses are fully air-conditioned and maintained for comfortable group travel." },
    { question: "Can I book 17 seater bus online in Pune?", answer: "Yes, customers can easily book 17 seater bus rental service online or through phone booking." },
    { question: "Do you provide buses for weddings and family tours?", answer: "Yes, Aaradhya Travels provides spacious 17 seater buses suitable for weddings, family vacations, and group tours." },
    { question: "Are 17 seater bus rental charges transparent?", answer: "Yes, Aaradhya Travels provides affordable and transparent pricing without hidden charges." },
    { question: "Is advance booking available for 17 seater bus rental?", answer: "Yes, advance booking is available and recommended during weekends, holidays, wedding seasons, and peak travel periods." },
    { question: "Do you provide pickup from Pune Airport and railway stations?", answer: "Yes, Aaradhya Travels provides pickup and drop services from Pune Airport, railway stations, hotels, and all major Pune locations." }
  ];

const testimonials = [
  {
    id: 1,
    name: "Mr. Ajay Deshpande",
    feedback:
      "We booked a 17 Seater bus on rent in Pune for our weekend trip and the experience was really comfortable. The vehicle was clean, well-maintained, and perfectly suited for our group travel.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Snehal Jadhav",
    feedback:
      "A 17 Seater bus rental in Pune made our family outing very convenient. Everyone could travel together easily, and the journey was smooth, safe, and enjoyable throughout.",
    rating: 5
  }
];








  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "Tempo-Traveller-On-Rent-in-Pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Mahabaleshwar Tempo Traveller", link: "Pune-to-Mahabaleshwar-Tempo-Traveller" },
    { place: "/images/keyword/3.jpg", text: "Pune to Outstation Tempo Traveller", link: "Pune-to-Outstation-Tempo-Traveller" },
    { place: "/images/keyword/4.jpg", text: "Mini Bus On Rent in Pune", link: "Mini-Bus-On-Rent-in-Pune" },
    { place: "/images/keyword/5.jpg", text: "Outstation Mini Bus on Rent Pune", link: "Outstation-Mini-Bus-on-Rent-Pune" },
    { place: "/images/keyword/6.jpg", text: "14 Seater Tempo Traveller on Rent in Pune", link: "14-Seater-Tempo-Traveller-on-Rent-in-Pune" },
    { place: "/images/keyword/7.jpg", text: "17 Seater Bus on Rent in Pune", link: "17-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/8.jpg", text: "Pune to Shirdi Tempo Traveller", link: "Pune-to-Shirdi-Tempo-Traveller" },
    { place: "/images/keyword/9.jpg", text: "20 Seater Bus on Rent in Pune", link: "20-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/10.jpg", text: "25 Seater Tempo Traveller on Rent in Pune", link: "25-Seater-Tempo-Traveller-on-Rent-in-Pune" },
    { place: "/images/keyword/11.jpg", text: "Tempo Traveller on Rent in Pimpri Chinchwad", link: "Tempo-Traveller-on-Rent-in-Pimpri-Chinchwad" },
    { place: "/images/keyword/12.jpg", text: "32 Seater Bus Rent in Pune", link: "32-Seater-Bus-Rent-in-Pune" },
    { place: "/images/keyword/13.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/14.jpg", text: "45 Seater Bus on Rent in Pune", link: "45-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/15.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-Seater-Bus-On-Rent-in-Pune" },
    { place: "/images/keyword/16.jpg", text: "Non AC Bus Rental Service in Pune", link: "Non-AC-Bus-Rental-Service-in-Pune" },
    { place: "/images/keyword/17.jpg", text: "Luxury Bus Rental in Pune", link: "Luxury-Bus-Rental-in-Pune" },
    { place: "/images/keyword/18.jpg", text: "Luxury Force Urbania On Rent in Pune", link: "Luxury-Force-Urbania-On-Rent-in-Pune" },
    { place: "/images/keyword/19.jpg", text: "Force Urbania Luxury Mini Bus On Rent", link: "Force-Urbania-Luxury-Mini-Bus-On-Rent" },
    { place: "/images/keyword/20.jpg", text: "Mini Bus On Rent in Pune", link: "Mini-Bus-On-Rent-in-Pune-2" },
    { place: "/images/keyword/21.jpg", text: "14 17 20 25 Seater Bus on Rent in Pune", link: "14-17-20-25-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/22.jpg", text: "Travel Agents in Pune for Mini Bus Hire", link: "Travel-Agents-in-Pune-for-Mini-Bus-Hire" },
    { place: "/images/keyword/23.jpg", text: "Tempo Traveller Hire in Pune", link: "Tempo-Traveller-Hire-in-Pune" },
  ];









const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "17 Seater Bus on Rent Pune",
  "image": "https://www.aaradhyatravels99.com/assets/images/17-seater-bus-on-rent-pune.jpg",
  "description": "Book 17 Seater Bus on rent in Pune with Aaradhya Travels for family trips, corporate tours, weddings, airport transfers, picnics, and outstation travel. Affordable AC and Non-AC 17 seater tempo traveller available for Goa, Mumbai, Nashik, Mahabaleshwar and more.",
  "brand": {
    "@type": "Brand",
    "name": "Aaradhya Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "3896"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "On Request",
    "availability": "https://schema.org/InStock",
    "url": "https://www.aaradhyatravels99.com/17-seater-bus-on-rent-pune"
  }
};







  return (
    <div>

<Helmet>
  <title>
    17 Seater Bus on Rent Pune | AC Tempo Traveller Hire | +91 9529697070
  </title>

  <meta
    name="description"
    content="Hire 17 Seater Bus on rent in Pune with Aaradhya Travels. Affordable AC and Non-AC tempo traveller available for Goa, Mumbai, Nashik, Mahabaleshwar, weddings, picnics, airport transfers, and outstation group tours."
  />

  <meta
    name="keywords"
    content="17 Seater bus on rent Pune, 17 seater bus on rent in pune price, 17 seater bus rate per km in pune, 17 seater bus on rent in pune, 17 seater AC Tempo Traveller On Rent in Pune, 17 seater non ac tempo traveller on rent in pune, 17 seater tempo traveller for mahabaleshwar from Pune, 17 Seater tempo traveller for pune to goa, 17 seater tempo traveller Pune to Nashik, 17 seater tempo traveller pune to mumbai rent, 17 seater tempo traveller on rent in hadapsar"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1
                  className="text-anime-style-3 text-center text-white"
                  data-cursor="-opaque"
                >
                  {cardData.keyword}
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>
















      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/7.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#FFB100', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Aaradhya Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Aaradhya Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Aaradhya Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


               <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919529697070" className="pc-call">+91 9529697070</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919529697070"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919529697070" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@aaradhyatravels99.com" className="pc-email">
                      booking@aaradhyatravels99.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Aaradhya Travels</strong><br />
                      Near RMD College, Opp. Chaudhary Parking, Warje, Pune - 411058
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Onesevenbusonrentinpune;